import { createStore } from 'stimulus-store';

export const multiDeviceTypeStore = createStore({
    name: 'multiDeviceTypeStore',
    type: Array,
    initialValue: []
});